import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    dateCell: 'Date',
    txHashCell: 'Tx Hash',
    statusCell: 'Status',
    costCell: 'Cost',
  },
};
